// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"55zIo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _preview = require("@storybook/addon-docs/dist/preview");
parcelHelpers.exportAll(_preview, exports);

},{"@storybook/addon-docs/dist/preview":"lByy2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"lByy2":[function(require,module,exports,__globalThis) {
"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res)=>function() {
        return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
    };
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: !0
    });
}, __copyProps = (to, from, except, desc)=>{
    if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from))!__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
        get: ()=>from[key],
        enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
    return to;
};
var __toESM = (mod, isNodeMode, target)=>(target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: !0
    }) : target, mod)), __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: !0
    }), mod);
var DocsRenderer_exports = {};
__export(DocsRenderer_exports, {
    DocsRenderer: ()=>DocsRenderer,
    defaultComponents: ()=>defaultComponents
});
var import_react, import_react_dom_shim, import_blocks, defaultComponents, ErrorBoundary, DocsRenderer, init_DocsRenderer = __esm({
    "src/DocsRenderer.tsx" () {
        "use strict";
        import_react = __toESM(require("428958c450befbdb")), import_react_dom_shim = require("41d27b90033cbed0"), import_blocks = require("ca4a8075a5a01e5a"), defaultComponents = {
            code: import_blocks.CodeOrSourceMdx,
            a: import_blocks.AnchorMdx,
            ...import_blocks.HeadersMdx
        }, ErrorBoundary = class extends import_react.Component {
            constructor(){
                super(...arguments);
                this.state = {
                    hasError: !1
                };
            }
            static getDerivedStateFromError() {
                return {
                    hasError: !0
                };
            }
            componentDidCatch(err) {
                let { showException } = this.props;
                showException(err);
            }
            render() {
                let { hasError } = this.state, { children } = this.props;
                return hasError ? null : import_react.default.createElement(import_react.default.Fragment, null, children);
            }
        }, DocsRenderer = class {
            constructor(){
                this.render = async (context, docsParameter, element)=>{
                    let components = {
                        ...defaultComponents,
                        ...docsParameter == null ? void 0 : docsParameter.components
                    }, TDocs = import_blocks.Docs;
                    return new Promise((resolve, reject)=>{
                        require("b183cc0b882ea0e5").then(({ MDXProvider })=>(0, import_react_dom_shim.renderElement)(import_react.default.createElement(ErrorBoundary, {
                                showException: reject,
                                key: Math.random()
                            }, import_react.default.createElement(MDXProvider, {
                                components
                            }, import_react.default.createElement(TDocs, {
                                context,
                                docsParameter
                            }))), element)).then(()=>resolve());
                    });
                }, this.unmount = (element)=>{
                    (0, import_react_dom_shim.unmountElement)(element);
                };
            }
        };
    }
});
var preview_exports = {};
__export(preview_exports, {
    parameters: ()=>parameters
});
module.exports = __toCommonJS(preview_exports);
var parameters = {
    docs: {
        renderer: async ()=>{
            let { DocsRenderer: DocsRenderer2 } = await Promise.resolve().then(function() {
                return require("b183cc0b882ea0e5");
            }).then((res)=>(init_DocsRenderer(), DocsRenderer_exports));
            return new DocsRenderer2;
        }
    }
};

},{"428958c450befbdb":"jEiK2","41d27b90033cbed0":"4xrA8","ca4a8075a5a01e5a":"7OB19","b183cc0b882ea0e5":"4bGZl"}],"4xrA8":[function(require,module,exports,__globalThis) {
"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: !0
    });
}, __copyProps = (to, from, except, desc)=>{
    if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from))!__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
        get: ()=>from[key],
        enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
    return to;
};
var __toESM = (mod, isNodeMode, target)=>(target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: !0
    }) : target, mod)), __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: !0
    }), mod);
var react_18_exports = {};
__export(react_18_exports, {
    renderElement: ()=>renderElement,
    unmountElement: ()=>unmountElement
});
module.exports = __toCommonJS(react_18_exports);
var import_react = __toESM(require("236531aa16c985fa")), import_client = __toESM(require("abe115786c0b4e92")), nodes = new Map, WithCallback = ({ callback, children })=>{
    let once = (0, import_react.useRef)();
    return (0, import_react.useLayoutEffect)(()=>{
        once.current !== callback && (once.current = callback, callback());
    }, [
        callback
    ]), children;
}, renderElement = async (node, el)=>{
    let root = await getReactRoot(el);
    return new Promise((resolve)=>{
        root.render(import_react.default.createElement(WithCallback, {
            callback: ()=>resolve(null)
        }, node));
    });
}, unmountElement = (el, shouldUseNewRootApi)=>{
    let root = nodes.get(el);
    root && (root.unmount(), nodes.delete(el));
}, getReactRoot = async (el)=>{
    let root = nodes.get(el);
    return root || (root = import_client.default.createRoot(el), nodes.set(el, root)), root;
};

},{"236531aa16c985fa":"jEiK2","abe115786c0b4e92":"18oA0"}],"18oA0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_clientJs);
var _clientJs = require("react-dom/client.js");
parcelHelpers.exportAll(_clientJs, exports);

},{"react-dom/client.js":"9MtVF","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"9MtVF":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i = m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
exports.createRoot = function(c, o) {
    i.usingClientEntryPoint = true;
    try {
        return m.createRoot(c, o);
    } finally{
        i.usingClientEntryPoint = false;
    }
};
exports.hydrateRoot = function(c, h, o) {
    i.usingClientEntryPoint = true;
    try {
        return m.hydrateRoot(c, h, o);
    } finally{
        i.usingClientEntryPoint = false;
    }
};

},{"aaccff5d309d9239":"a0ZmT"}],"4bGZl":[function(require,module,exports,__globalThis) {
module.exports = require("dab598e2aeedf001")(require("bf7f9ac51cf57631").resolve("dlix5")).then(()=>module.bundle.root('5erN3'));

},{"dab598e2aeedf001":"bvDWj","bf7f9ac51cf57631":"kK08P"}],"eG5no":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=preview.7f037686.js.map
